import React from 'react';
import { connect } from 'react-redux';

import { screen } from '$gcomponents/hoc';
import { ContentWrapper } from '$styles/general';
import { ApiList } from '$gcomponents/reusables';
import ItemModel from '$fbusiness/models/item';

import { IonPageWrapper } from './styles';
import { dataSource } from './categoryList';
import ItemSimpleView from '$fcomponents/itemSimpleView';
import ItemListContainer from '$components/itemListContainer';
import { getPublicFactoryId } from '$gbusiness/helpers/util';
import CurrentStateModel from '$fbusiness/models/currentState';
import Header from '$fcomponents/header';
import IonContentWrapper from '$fcomponents/ionContentWrapper';

interface SearchScreenProps {
  match: any;
  currentState: CurrentStateModel;
  addToCart: Function;
  cleanItem;
  fetchItem;
}

const SearchScreen: React.FC<SearchScreenProps> = ({ match, currentState }) => {
  const { query } = match.params;
  const filter = {
    query,
    factoryId: getPublicFactoryId(),
  };
  const { hidePrice, ebrochure, settings } = currentState;

  return (
    <IonPageWrapper>
      <IonContentWrapper>
        <Header titleText={`"${query}"`} />
        <ContentWrapper>
          {query && (
            <ItemListContainer currentState={currentState}>
              {(onAddCart, onViewItem, isWholesale) => (
                <ApiList dataSource={dataSource} filters={filter}>
                  {(item: ItemModel, index) => (
                    <ItemSimpleView
                      item={item}
                      index={index}
                      settings={settings}
                      hidePrice={hidePrice}
                      ebrochure={ebrochure}
                      onClick={onViewItem}
                      onAddCart={onAddCart}
                      isWholesale={isWholesale}
                    />
                  )}
                </ApiList>
              )}
            </ItemListContainer>
          )}
        </ContentWrapper>
      </IonContentWrapper>
    </IonPageWrapper>
  );
};

const mapStateToProps = (state, ownProps) => ({
  resetOnRoute: true,
});

const connected = connect(mapStateToProps, null);

export default connected(screen(SearchScreen));
